import './index.scss';
import Skeleton from '@mui/material/Skeleton';

const AddressListSkeleton = () => {
    return (
        <div className="my-account__content">
            <div className="below-32">
                <h1 className="my-account__content__title my-account__address-list">
                    <Skeleton animation="wave" variant="text" className="myAccountTitle" height={40} />&nbsp;
                </h1>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="below-24">
                            <strong>
                                <Skeleton animation="wave" variant="text" width={200} height={25}/>
                            </strong>
                            <div>
                                <Skeleton animation="wave" variant="text" width={200} height={25}/>
                            </div>
                            <ul id="shipping-add-ul" className="account-address-list address-list base">
                                <li className="address__item">
                                    <Skeleton animation="wave" variant="rounded" height={90}/>
                                </li>
                                <li className="address__item">
                                    <Skeleton animation="wave" variant="rounded" height={90} />
                                </li>
                            </ul>
                        </div>
                        <div className="below-24">
                            <strong>
                                <Skeleton animation="wave" variant="text" width={200} height={25}/>
                            </strong>
                            <div>
                                <Skeleton animation="wave" variant="text" width={200} height={25}/>
                            </div>
                            <ul id="billing-add-ul" className="account-address-list address-list base">
                                <li className="address__item">
                                    <Skeleton animation="wave" variant="rounded" height={90}/>
                                </li>
                                <li className="address__item">
                                    <Skeleton animation="wave" variant="rounded" height={90}/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AddressListSkeleton;